import { Model } from "./model";
import { CpeId } from "./deviceDataModelEditor/cpeId";

const TASK_TIMEOUT = 3;

export class DeviceDataModelEditor extends Model {
    constructor(props, attributes) {
        super(props, Object.assign({}, attributes));
        this._cpeIds = {};
    }

    urlRoot() {
        return "/deviceDataModelEditor";
    }

    url() {
        return this.urlRoot();
    }

    cpeId(value) {
        if (!this._cpeIds[value]) {
            this._cpeIds[value] = new CpeId({ value: value, parent: this });
        }
        return this._cpeIds[value];
    }
}
